export default {"src":"/_next/static/media/article.a35b4411.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};